
















import { defineComponent } from '@vue/composition-api/dist/vue-composition-api'
import { formatTelephone } from '@/libs/formatters/telephone'
import { useCountries } from '@/composable/repositories/useCountries'
import type { Address } from '@futureecom/futureecom-js'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'OrderableAddressPreview',

  props: {
    value: {
      type: Object as PropType<Address>,
      required: true
    }
  },

  setup() {
    return {
      formatTelephone,
      getCountryName: useCountries().getCountryName
    }
  }
})
